// @flow

import env from './env.json'

export const ROOT_URL = process.env.ROOT_URL || env.SERVER || 'https://qa-granduke.net'
export const SERVER = process.env.FC_SERVER || `${ROOT_URL}`.replace(/http[s]*:\/\//, '')
export const PROTOCOL = process.env.PROTOCOL || env.PROTOCOL
export const STRIPE_PUBLIC_TOKEN = process.env.STRIPE_PUBLIC_TOKEN || env.STRIPE_PUBLIC_TOKEN
export const LOGROCKET_APP_ID = process.env.LOGROCKET_APP_ID || env.LOGROCKET_APP_ID
